/* eslint-disable max-len */
const faq = `

<div class="accordion-wrapper">

<div class="left">

<div class="accordion">
<input type="checkbox" id="chck1">
<label class="accordion-label" for="chck1">Applying for a loan after paying off the previous loan</label>
<div class="accordion-content">
<p>
You can resubmit a loan application on the Easycash app, then a review or reassessment process will be carried out.
</p>
</div>
</div>

<div class="accordion">
<input type="checkbox" id="chck2">
<label class="accordion-label" for="chck2">Easycash loan tenure</label>
<div class="accordion-content">
<p>
The current Easycash loan tenure is 15 days and 1 month per period. The loan tenure will be determined by our review process in the system.
</p>
</div>
</div>

<div class="accordion">
<input type="checkbox" id="chck3">
<label class="accordion-label" for="chck3">Verification code problems</label>
<div class="accordion-content">
<p>
The current OTP code submission can be accessed via voice message, WhatsApp, or SMS. Make sure your signal is stable to receive the OTP code.
</p>
</div>
</div>

<div class="accordion">
<input type="checkbox" id="chck4">
<label class="accordion-label" for="chck4">Face verification problem when applying for a loan</label>
<div class="accordion-content">
<p>
To take a face verification, make sure you have given access to the camera and follow the steps in Easycash. Ensure that you have sufficient lighting and stable internet network.
</p>
</div>
</div>

<div class="accordion">
<input type="checkbox" id="chck5">
<label class="accordion-label" for="chck5">How to apply for a loan at Easycash</label>
<div class="accordion-content">
<p>
Regarding Easycash application registration, you can follow the following steps:
</p>

<ol>
<li>Download the Easycash application on the <a href="https://play.google.com/store/apps/details?id=com.fintopia.idnEasycash.google&amp;pli=1" target="_blank">Google Play</a> or <a href="https://apps.apple.com/id/app/id1435044790" target="_blank">App Store</a>.</li>
<li>Enter your phone number and the OTP code will be sent. The OTP code can be accessed via SMS, voice call, and also WhatsApp.</li>
<li>Please fill in the required data in the Easycash app.</li>
<li>Please wait for the data verification process.</li>
<li>After you are approved, please choose the nominal amount and the loan tenure according to your needs.</li>
<li>Make sure that your submitted data and documents are valid according to the requirements in the Easycash app.</li>
</ol>
</div>
</div>

<div class="accordion">
<input type="checkbox" id="chck6">
<label class="accordion-label" for="chck6">Can I apply for more than one loan?</label>
<div class="accordion-content">
<p>
It depends on the loan limit that you got. Please check regularly and make sure to maintain a good payment history.
</p>
</div>
</div>

</div>

<div class="right">

<div class="accordion">
<input type="checkbox" id="chck7">
<label class="accordion-label" for="chck7">Why was my loan application rejected?</label>
<div class="accordion-content">
<p>
If your application did not pass the review, you do not meet the loan application requirements. Please check regularly on the Easycash app.
</p>
</div>
</div>

<div class="accordion">
<input type="checkbox" id="chck8">
<label class="accordion-label" for="chck8">What is the loan amount that can be applied for?</label>
<div class="accordion-content">
<p>
The nominal loan that can be submitted starts from IDR100,000 to IDR100,000,000.
</p>
</div>
</div>

<div class="accordion">
<input type="checkbox" id="chck9">
<label class="accordion-label" for="chck9">Easycash loan disbursement</label>
<div class="accordion-content">
<p>
Regarding your funds disbursement, please wait a maximum of 24 hours. If it has been more than 24 hours and you still haven't received it yet, please attach an account statement and contact Easycash Customer Service at Call Center <a href="tel:1500866">1500866</a>, email: <a href="mailto: cs.pinjaman@easycash.id ">cs.pinjaman@easycash.id </a>, or live chat on the Easycash application.
</p>
</div>
</div>

<div class="accordion">
<input type="checkbox" id="chck10">
<label class="accordion-label" for="chck10">Can I increase my loan limit?</label>
<div class="accordion-content">
<p>
Currently, the loan amount offered by the Easycash is as stated in the app. Please continue to maintain the credibility of your data by making payments on time in order to get attractive offers from us.
</p>
</div>
</div>

<div class="accordion">
<input type="checkbox" id="chck11">
<label class="accordion-label" for="chck11">How can we receive the disbursed fund from Easycash?</label>
<div class="accordion-content">
Regarding the fund disbursement, you can use the available bank accounts on the Easycash app.
</p>
</div>
</div>

</div>

</div>

`;

export default faq;
